import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { AuthenticationService } from "../authentication/authentication.service";
import { NotificationService } from "../notifications/reservation-notifications.service";
import { mergeMap } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FireMessagingService {

  //#region Fields
  private userId: string | undefined;
  //#endregion

  //#region Constructor
  constructor(private angularFireMessaging: AngularFireMessaging,
              private notificationsService: NotificationService,
              private authService: AuthenticationService) {
    this.authService.loginUser.subscribe((userData) => {
      if (userData?.id) {
        if (this.userId !== userData.id) {
          this.userId = userData.id;
          this.requestPermission();
        }
      } else {
        this.userId = undefined;
      }
    });
  }
  //#endregion

  //#region Public Methods
  requestPermission(): void {
    if (!this.userId) {
      return;
    }
    this.angularFireMessaging.requestToken.subscribe({
      next: (token) => {
        if (token) {
          this.authService.registerFCMToken(this.userId!, token).subscribe();
        }
      },
      error: (err) => {
        console.error('Unable to get permission to notify.', err);
      }
    });
  }

  removeToken(): void {
    this.angularFireMessaging.getToken.pipe(mergeMap(token => {
      return this.angularFireMessaging.deleteToken(token!);
    })).subscribe();
  }
  //#endregion
}
